import { css } from 'lit';
export const mobileListStyle = css `
  :host(.mobile-view) {
    padding: 12px 8px;
  }
`;
//# sourceMappingURL=mobile-list.style.js.map